import { useTranslation } from 'react-i18next';
import classNames from './LoginForm.module.scss';
import React from 'react';

import TheButton from '../TheButton/TheButton';

interface GoogleLoginErrorProps {
  onSubmit: () => void;
}

const ClassCodePasswordRequested = ({ onSubmit }: GoogleLoginErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames.loginError}>
      <h2>{t('resetPasswordRequest')}</h2>
      <span className={classNames.description}>{t('contactTeacher')} </span>
      <TheButton
        className={classNames.closeBtn}
        text={t('ok')}
        shouldRecolor={false}
        emitOnClick={onSubmit}
      />
    </div>
  );
};

export default ClassCodePasswordRequested;
